const judgeDeviceType = (() => {
    let deviceType = null;
  
    return () => {
      if (!deviceType) {
        const ua = window.navigator.userAgent.toLocaleLowerCase();
        const isIOS = /iphone|ipad|ipod/.test(ua);
        const isAndroid = /android/.test(ua);
        const isMiuiBrowser = /miuibrowser/.test(ua);
        deviceType = {
          isIOS: isIOS,
          isAndroid: isAndroid,
          isMiuiBrowser: isMiuiBrowser
        };
      }
  
      return deviceType;
    };
  })();

function activeElementScrollIntoView() {
    const activeEl = document.activeElement;
    if (
      activeEl.tagName === 'INPUT' || 
      activeEl.tagName === 'TEXTAREA'
    ) {
      window.setTimeout(() => {
        if ('scrollIntoView' in activeEl) {
          activeEl.scrollIntoView();
        } else {
          activeEl.scrollIntoViewIfNeeded();
        }
      }, 100);
    }
  }
  
  
  function listenAndroidKeybord() {
    const { isAndroid , isMiuiBrowser} = judgeDeviceType();
  
    if (isAndroid) {
      const androidResize = function() {
        // 将当前焦点元素滚动到可视区
        activeElementScrollIntoView();
      };
  
      // android 键盘弹出、收起，可视区高度会发生变化
      window.addEventListener('resize', androidResize, false);
  
      return () => {
        window.removeEventListener('resize', androidResize, false);
      };
    } else  if (isMiuiBrowser) {
        const inputFocus = function() {
          document.body.style.marginBottom = '50px';
          activeElementScrollIntoView();
        };
    
        const inputBlur = function() {
          document.body.style.marginBottom = '0px';
          activeElementScrollIntoView();
        };
    
        let $inputs = document.getElementsByTagName('input');
        for (let i = 0; i < $inputs.length; i++) {
          $inputs[i].addEventListener('focus', inputFocus, false);
          $inputs[i].addEventListener('blur', inputBlur, false);
        }
    
        return () => {
          for (let i = 0; i < $inputs.length; i++) {
            $inputs[i].removeEventListener('focus', inputFocus, false);
            $inputs[i].removeEventListener('blur', inputBlur, false);
          }
        };
      }
  }

  export { listenAndroidKeybord }


// WEBPACK FOOTER //
// ./src/util/app-compatible.js